(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2914,2597,1620,5901,9600,8960],{

/***/ 93228:
/***/ (function(module) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),

/***/ 51704:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(52153);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 82941:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRange = __webpack_require__(93228),
    isIterateeCall = __webpack_require__(82406),
    toFinite = __webpack_require__(5707);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),

/***/ 52153:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 2689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createRange = __webpack_require__(82941);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),

/***/ 5707:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toNumber = __webpack_require__(7642);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 7642:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(51704),
    isObject = __webpack_require__(29259),
    isSymbol = __webpack_require__(4795);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 60574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ customer_insights; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/templates/LogoCarousel/index.ts + 1 modules
var LogoCarousel = __webpack_require__(6087);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ../../libs/templates/Forms/DemoForm/index.ts + 3 modules
var DemoForm = __webpack_require__(98960);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/UseCases/CustomerInsights/components/Hero/assets/Hero@2x.png
var Hero_2x = __webpack_require__(99673);
var Hero_2x_default = /*#__PURE__*/__webpack_require__.n(Hero_2x);
// EXTERNAL MODULE: ./src/views/UseCases/CustomerInsights/components/Hero/assets/Hero.webp
var Hero = __webpack_require__(2461);
var Hero_default = /*#__PURE__*/__webpack_require__.n(Hero);
// EXTERNAL MODULE: ./src/views/UseCases/CustomerInsights/components/Hero/assets/Hero@2x.webp
var assets_Hero_2x = __webpack_require__(1346);
var assets_Hero_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Hero_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/UseCases/CustomerInsights/components/Hero/HeroImage.tsx








var HeroImage = function HeroImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Picture, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((Hero_default()), ", ").concat((assets_Hero_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: (Hero_2x_default()),
      alt: "Illustration: Enable customer insights with Twilio Segment",
      width: "640",
      height: "540",
      loading: "lazy"
    })]
  });
};

var Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "e1ovzyqj0"
} : 0)( true ? "" : 0);

/* harmony default export */ var Hero_HeroImage = (HeroImage);
;// CONCATENATED MODULE: ./src/views/UseCases/CustomerInsights/components/Hero/Hero.tsx










var copy = {
  overline: "Enable customer insights with Twilio Segment",
  heading: "Make informed decisions with comprehensive customer insights",
  description: "Transform your business intelligence with Segment, empowering your teams to use real-time, accurate customer data for smarter strategies, enhanced growth, and increased customer satisfaction."
};

var Hero_Hero = function Hero(_ref) {
  var externalAppearance = _ref.appearance;
  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);

  var afterContent = (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SignupButton/* SignupButtonText */._, {
    size: "medium",
    tag: "a",
    children: ["Create a free account", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronRightIcon */.XC, {})]
  });

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: appearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHero, {
        variant: "2Col",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* Copy */.CK, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: copy.overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "homeH2",
            tag: "h1",
            children: copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            variant: "homePExtraLarge",
            tag: "p",
            children: copy.description
          }, copy.description), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Form */.l0, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DemoFormContainer, {
              "data-hook": "demoFormContainer",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DemoForm/* default */.Z, {
                isProgressive: true,
                customFormIdentifier: "site-use-case-customer-insights-demo",
                customTrackingType: "site-use-case-customer-insights-demo",
                after: afterContent
              })
            })
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_HeroImage, {})
        })]
      })
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e1qkx9k2"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[100];
}, ";" + ( true ? "" : 0));

var StyledHero = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "e1qkx9k1"
} : 0)(recipes_Hero/* Wrapper */.im, "{gap:50px;}" + ( true ? "" : 0));

var DemoFormContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1qkx9k0"
} : 0)("margin-top:50px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("md");
}, "{margin-top:0;}" + ( true ? "" : 0));

/* harmony default export */ var components_Hero_Hero = (Hero_Hero);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
// EXTERNAL MODULE: ./src/views/UseCases/CustomerInsights/components/DeepenUnderstanding/DeepenUnderstandingImage/assets/DeepenUnderstanding.webp
var DeepenUnderstanding = __webpack_require__(99);
var DeepenUnderstanding_default = /*#__PURE__*/__webpack_require__.n(DeepenUnderstanding);
// EXTERNAL MODULE: ./src/views/UseCases/CustomerInsights/components/DeepenUnderstanding/DeepenUnderstandingImage/assets/DeepenUnderstanding@2x.png
var DeepenUnderstanding_2x = __webpack_require__(96820);
var DeepenUnderstanding_2x_default = /*#__PURE__*/__webpack_require__.n(DeepenUnderstanding_2x);
// EXTERNAL MODULE: ./src/views/UseCases/CustomerInsights/components/DeepenUnderstanding/DeepenUnderstandingImage/assets/DeepenUnderstanding@2x.webp
var assets_DeepenUnderstanding_2x = __webpack_require__(69593);
var assets_DeepenUnderstanding_2x_default = /*#__PURE__*/__webpack_require__.n(assets_DeepenUnderstanding_2x);
;// CONCATENATED MODULE: ./src/views/UseCases/CustomerInsights/components/DeepenUnderstanding/DeepenUnderstandingImage/DeepenUnderstandingImage.tsx








var DeepenUnderstandingImage = function DeepenUnderstandingImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DeepenUnderstandingImage_Picture, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((DeepenUnderstanding_default()), ", ").concat((assets_DeepenUnderstanding_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: (DeepenUnderstanding_2x_default()),
      alt: "Illustration: Deepen understanding with a 360\xB0 view of your customers",
      width: "624",
      height: "511",
      loading: "lazy"
    })]
  });
};

var DeepenUnderstandingImage_Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "evejqr60"
} : 0)( true ? "" : 0);

/* harmony default export */ var DeepenUnderstandingImage_DeepenUnderstandingImage = (DeepenUnderstandingImage);
;// CONCATENATED MODULE: ./src/views/UseCases/CustomerInsights/components/DeepenUnderstanding/DeepenUnderstanding.tsx









var DeepenUnderstanding_copy = {
  title: "Deepen understanding with a 360\xB0 view of your customers",
  description: "With comprehensive customer insights, create personalized campaigns that are cohesive and actionable in real time.",
  links: [{
    text: "Self-serve analytics",
    href: "self-serve-analytics"
  }, {
    text: "Data science modeling & advanced analytics",
    href: "data-science-modeling"
  }],
  elements: [{
    title: "Unify fragmented customer data",
    description: "Convert disjointed data into actionable insights and precise predictive analytics enabling personalized customer experiences and informed business strategies."
  }, {
    title: "Take control of your data and act on real-time insights",
    description: "Implement real-time data governance and validation with Segment, establishing a trustworthy foundation for generating actionable insights and sophisticated modeling."
  }, {
    title: "Measure ROI and improve experimentation",
    description: "Measure the ROI of your engagement strategies accurately with Segment, from marketing campaigns to product investments, all while enhancing campaign effectiveness and customer satisfaction."
  }]
};

var DeepenUnderstanding_DeepenUnderstanding = function DeepenUnderstanding() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DeepenUnderstanding_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionBaseTitle, {
      variant: "noCopy",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h2",
            children: DeepenUnderstanding_copy.title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            children: DeepenUnderstanding_copy.description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinksWrapper, {
            children: DeepenUnderstanding_copy.links.map(function (link, i) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledTypography, {
                variant: "pLarge",
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomDivider, {
                  children: i === 0 ? null : "|"
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                  href: "#".concat(link.href),
                  onClick: function onClick(e) {
                    e.preventDefault();
                    (0,useScrollToAnchor/* scrollToAnchor */.d)(link.href);
                  },
                  children: link.text
                })]
              }, link.text);
            })
          })]
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionBaseContent, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeepenUnderstandingImage_DeepenUnderstandingImage, {})
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        alignSelf: "center",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
          children: DeepenUnderstanding_copy.elements.map(function (_ref, key) {
            var title = _ref.title,
                description = _ref.description;
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
                tag: "h3",
                variant: "pLargeBold",
                children: title
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
                tag: "p",
                variant: "pMedium",
                children: description
              })]
            }, key);
          })
        })
      })]
    })]
  });
};

var DeepenUnderstanding_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e11cfjqz5"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.mint[10];
}, ";" + ( true ? "" : 0));

var StyledSectionBaseTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e11cfjqz4"
} : 0)(Section/* Wrapper */.im, "{padding-top:80px;padding-bottom:0;}" + ( true ? "" : 0));

var StyledSectionBaseContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e11cfjqz3"
} : 0)(Section/* Wrapper */.im, "{padding-top:60px;padding-bottom:50px;}" + ( true ? "" : 0));

var LinksWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e11cfjqz2"
} : 0)("display:inline-flex;gap:12px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("sm");
}, "{flex-direction:column;align-items:center;gap:20px;}" + ( true ? "" : 0));

var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e11cfjqz1"
} : 0)("display:inline-flex;gap:12px;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.down("sm");
}, "{margin:0;}" + ( true ? "" : 0));

var CustomDivider = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e11cfjqz0"
} : 0)(function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.down("sm");
}, "{display:none;}" + ( true ? "" : 0));

/* harmony default export */ var components_DeepenUnderstanding_DeepenUnderstanding = (DeepenUnderstanding_DeepenUnderstanding);
// EXTERNAL MODULE: ../../libs/matcha/components/FeatureBox/index.ts
var FeatureBox = __webpack_require__(33514);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ./src/views/UseCases/CustomerInsights/components/SelfServeAnalytics/assets/SelfServeAnalytics.png
var SelfServeAnalytics = __webpack_require__(57394);
var SelfServeAnalytics_default = /*#__PURE__*/__webpack_require__.n(SelfServeAnalytics);
// EXTERNAL MODULE: ./src/views/UseCases/CustomerInsights/components/SelfServeAnalytics/assets/SelfServeAnalytics.webp
var assets_SelfServeAnalytics = __webpack_require__(61614);
var assets_SelfServeAnalytics_default = /*#__PURE__*/__webpack_require__.n(assets_SelfServeAnalytics);
;// CONCATENATED MODULE: ./src/views/UseCases/CustomerInsights/components/SelfServeAnalytics/SelfServeAnalyticsImage.tsx







var SelfServeAnalyticsImage = function SelfServeAnalyticsImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SelfServeAnalyticsImage_Picture, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((assets_SelfServeAnalytics_default()))
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: (SelfServeAnalytics_default()),
      alt: "Illustration: Audience building and activation",
      width: "624",
      height: "511",
      loading: "lazy"
    })]
  });
};

var SelfServeAnalyticsImage_Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "e8bjlpm0"
} : 0)( true ? "" : 0);

/* harmony default export */ var SelfServeAnalytics_SelfServeAnalyticsImage = (SelfServeAnalyticsImage);
;// CONCATENATED MODULE: ./src/views/UseCases/CustomerInsights/components/SelfServeAnalytics/SelfServeAnalytics.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var SelfServeAnalytics_copy = {
  title: "Self-serve analytics",
  description: "Get instant customer insights that are accessible organization-wide.",
  elements: [{
    title: "No more manual data processing",
    description: "Pulling data manually can bottleneck your business, delaying critical decisions. Segment helps you collect and clean data from any source and create unified customer profiles that are accessible to every team in your organization."
  }, {
    title: "Comprehensive insights without the wait",
    description: "Empower your teams with immediate access to clean, consented customer data and seamless integration with your existing analytics platforms accelerating insights and enhancing decision-making."
  }, {
    title: "Transform your campaigns with robust data",
    description: "Segment provides more than just data access; it equips each byte with the potential to unlock insights, guiding more informed decisions across your organization."
  }],
  buttonText: "Explore Unify",
  buttonUrl: "/product/unify/"
};

var SelfServeAnalytics_SelfServeAnalytics = function SelfServeAnalytics() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SelfServeAnalytics_Wrapper, {
    id: "self-serve-analytics",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelfServeAnalytics_StyledSectionBaseTitle, {
      variant: "noCopy",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h2",
            children: SelfServeAnalytics_copy.title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            children: SelfServeAnalytics_copy.description
          })]
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SelfServeAnalytics_StyledSectionBaseContent, {
      reverse: true,
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelfServeAnalytics_SelfServeAnalyticsImage, {})
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        alignSelf: "center",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
          children: SelfServeAnalytics_copy.elements.map(function (_ref, key) {
            var title = _ref.title,
                description = _ref.description;
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledFeatureBoxBase, {
              alignment: "left",
              appearance: "twilioLight",
              headerPosition: "left",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                  children: title
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                  tokens: {
                    color: theme.palette.twilio.gray[80]
                  },
                  variant: "pMedium",
                  children: description
                }), key === SelfServeAnalytics_copy.elements.length - 1 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
                  href: (0,getAbsoluteUrl/* default */.Z)(SelfServeAnalytics_copy.buttonUrl, pageConfig),
                  children: SelfServeAnalytics_copy.buttonText
                })]
              })
            }, key);
          })
        })
      })]
    })]
  });
};

var SelfServeAnalytics_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1kjhr853"
} : 0)( true ? "" : 0);

var StyledFeatureBoxBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(FeatureBox/* default */.ZP,  true ? {
  target: "e1kjhr852"
} : 0)( true ? {
  name: "1ev7hvu",
  styles: "gap:0;grid-template-columns:22px auto"
} : 0);

var SelfServeAnalytics_StyledSectionBaseTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1kjhr851"
} : 0)(Section/* Wrapper */.im, "{padding-top:80px;padding-bottom:0;}" + ( true ? "" : 0));

var SelfServeAnalytics_StyledSectionBaseContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1kjhr850"
} : 0)(Section/* Wrapper */.im, "{padding-top:80px;padding-bottom:80px;}" + ( true ? "" : 0));

/* harmony default export */ var components_SelfServeAnalytics_SelfServeAnalytics = (SelfServeAnalytics_SelfServeAnalytics);
// EXTERNAL MODULE: ./src/views/UseCases/CustomerInsights/components/DataScienceModeling/assets/DataScienceModeling.png
var DataScienceModeling = __webpack_require__(92888);
var DataScienceModeling_default = /*#__PURE__*/__webpack_require__.n(DataScienceModeling);
// EXTERNAL MODULE: ./src/views/UseCases/CustomerInsights/components/DataScienceModeling/assets/DataScienceModeling.webp
var assets_DataScienceModeling = __webpack_require__(55592);
var assets_DataScienceModeling_default = /*#__PURE__*/__webpack_require__.n(assets_DataScienceModeling);
// EXTERNAL MODULE: ./src/views/UseCases/CustomerInsights/components/DataScienceModeling/assets/DataScienceModeling@2x.webp
var DataScienceModeling_2x = __webpack_require__(63735);
var DataScienceModeling_2x_default = /*#__PURE__*/__webpack_require__.n(DataScienceModeling_2x);
;// CONCATENATED MODULE: ./src/views/UseCases/CustomerInsights/components/DataScienceModeling/DataScienceModelingImage.tsx








var DataScienceModelingImage = function DataScienceModelingImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DataScienceModelingImage_Picture, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((assets_DataScienceModeling_default()), ", ").concat((DataScienceModeling_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: (DataScienceModeling_default()),
      alt: "Illustration: Data science modeling & advanced analytics",
      width: "624",
      height: "558",
      loading: "lazy"
    })]
  });
};

var DataScienceModelingImage_Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "e1uyck5o0"
} : 0)( true ? "" : 0);

/* harmony default export */ var DataScienceModeling_DataScienceModelingImage = (DataScienceModelingImage);
;// CONCATENATED MODULE: ./src/views/UseCases/CustomerInsights/components/DataScienceModeling/DataScienceModeling.tsx


function DataScienceModeling_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var DataScienceModeling_copy = {
  title: "Data science modeling & advanced analytics",
  description: "Leverage out-of-the-box data science and analytics for personalized experiences that boost revenue and customer loyalty.",
  elements: [{
    title: "Your data, decoded",
    description: "Segment simplifies the process of converting an abundance of data into precise, actionable insights that elevate customer experiences and drive revenue growth, making advanced analytics and data science a snap."
  }, {
    title: "Predictive insights for enhanced customer experiences",
    description: "CustomerAI Predictions streamlines predicting future behavior and identifying key audiences primed for engagement, by leveraging predictive lifetime value (LTV), purchase likelihood, churn, or other tracked events, enabling personalized experiences without tapping technical teams."
  }, {
    title: "Seamless integration with your data warehouse",
    description: "Segment simplifies the training and activation of machine learning models by providing real-time, identity-resolved customer data that can be easily ported to your data warehouse."
  }],
  buttonText: "Explore CustomerAI Predictions",
  buttonUrl: "/solutions/ai/customerai-predictions/"
};

var DataScienceModeling_DataScienceModeling = function DataScienceModeling() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DataScienceModeling_Wrapper, {
    id: "data-science-modeling",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DataScienceModeling_StyledSectionBaseTitle, {
      variant: "noCopy",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h2",
            children: DataScienceModeling_copy.title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            children: DataScienceModeling_copy.description
          })]
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DataScienceModeling_StyledSectionBaseContent, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DataScienceModeling_DataScienceModelingImage, {})
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        alignSelf: "center",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
          children: DataScienceModeling_copy.elements.map(function (_ref, key) {
            var title = _ref.title,
                description = _ref.description;
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DataScienceModeling_StyledFeatureBoxBase, {
              alignment: "left",
              appearance: "twilioLight",
              headerPosition: "left",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                  children: title
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                  tokens: {
                    color: theme.palette.twilio.gray[80]
                  },
                  variant: "pMedium",
                  children: description
                }), key === DataScienceModeling_copy.elements.length - 1 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
                  href: DataScienceModeling_copy.buttonUrl,
                  children: DataScienceModeling_copy.buttonText
                })]
              })
            }, key);
          })
        })
      })]
    })]
  });
};

var DataScienceModeling_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e3xvb023"
} : 0)( true ? "" : 0);

var DataScienceModeling_StyledFeatureBoxBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(FeatureBox/* default */.ZP,  true ? {
  target: "e3xvb022"
} : 0)( true ? {
  name: "1ev7hvu",
  styles: "gap:0;grid-template-columns:22px auto"
} : 0);

var DataScienceModeling_StyledSectionBaseTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e3xvb021"
} : 0)(Section/* Wrapper */.im, "{padding-top:80px;padding-bottom:0;}" + ( true ? "" : 0));

var DataScienceModeling_StyledSectionBaseContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e3xvb020"
} : 0)(Section/* Wrapper */.im, "{padding-top:80px;padding-bottom:80px;}" + ( true ? "" : 0));

/* harmony default export */ var components_DataScienceModeling_DataScienceModeling = (DataScienceModeling_DataScienceModeling);
// EXTERNAL MODULE: ../../libs/matcha/components/IconWrapper/index.ts + 2 modules
var IconWrapper = __webpack_require__(79600);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Brandbook.ts + 93 modules
var Brandbook = __webpack_require__(52065);
;// CONCATENATED MODULE: ./src/views/UseCases/CustomerInsights/components/WhySegment/WhySegment.tsx


function WhySegment_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var WhySegment_copy = {
  heading: "Why Segment",
  elements: [{
    icon: Brandbook/* FormFields */.Mt,
    heading: "Real-time, comprehensive customer insights",
    description: "Make the most of your customer data using Segment for real-time analytics and predictive modeling. Our platform ensures that every decision is backed by up-to-the-minute data, enabling you to stay ahead in delivering personalized customer experiences."
  }, {
    icon: Brandbook/* GraphsFlowChartDown */.rI,
    heading: "Simplify data science with CustomerAI Predictions",
    description: "Leverage CustomerAI Predictions to simplify data science for your marketing team. Easily predict behaviors, fostering intelligent, predictive strategies and campaigns that proactively enhance growth and customer satisfaction."
  }, {
    icon: Brandbook/* PieChart */.uc,
    heading: "Unify customer data for strategic decision-making",
    description: "Break down data silos with Segment's unified customer profiles and transform fragmented   customer data into a single, coherent view\u2014empowering your teams to make strategic, data-driven decisions."
  }]
};

var WhySegment = function WhySegment() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WhySegment_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSection, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h2",
          tag: "h2",
          children: WhySegment_copy.heading
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
          columns: 1,
          overrides: {
            md: 3
          },
          children: WhySegment_copy.elements.map(function (_ref) {
            var Icon = _ref.icon,
                heading = _ref.heading,
                description = _ref.description;
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* default */.ZP, {
              headerPosition: "top",
              alignment: "left",
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Header */.h4, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledIconWrapper, {
                  variant: "circle",
                  elevation: 1,
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
                    size: "large"
                  })
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                  children: heading
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                  variant: "pMedium",
                  children: description
                })]
              })]
            }, heading);
          })
        })
      })]
    })
  });
};

var StyledIconWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(IconWrapper/* default */.Z,  true ? {
  target: "e1x406z72"
} : 0)( true ? {
  name: "1m208wm",
  styles: "width:64px;height:64px;padding:6px"
} : 0);

var WhySegment_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1x406z71"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.mint[10];
}, ";" + ( true ? "" : 0));

var StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1x406z70"
} : 0)( true ? {
  name: "1fygc5t",
  styles: "max-width:1280px"
} : 0);

/* harmony default export */ var WhySegment_WhySegment = (WhySegment);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/templates/TestimonialSlider/index.ts + 11 modules
var TestimonialSlider = __webpack_require__(88302);
// EXTERNAL MODULE: ../../libs/matcha/components/CompanyLogos/CompanyMono.ts + 250 modules
var CompanyMono = __webpack_require__(68536);
// EXTERNAL MODULE: ../../libs/matcha/components/CompanyLogos/Company.ts + 258 modules
var Company = __webpack_require__(13922);
;// CONCATENATED MODULE: ./src/views/UseCases/CustomerInsights/components/TestimonialsSlider/data.tsx






var testimonialData = function testimonialData() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return [{
    company: "sanofi",
    text: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: "\u201CPreviously, we would work with our data by moving it, then using it. Now, with Segment, we can use data while we move it. The big benefit of Segment is not only its ETL capabilities to move data from point A to point B but Segment is also able to unify data quickly in the warehouse before we can send the data to campaign tools.\""
    }),
    name: "Rick Troiani",
    position: "Director of Omni-Channel Engagement Architecture",
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* SanofiMonoLogo */.he8, {
      color: theme.palette.twilio.gray[70]
    }),
    logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* SanofiLogo */.usZ, {}),
    logoName: "Sanofi",
    extendedRate: "93%",
    extendedText: "time saved adding new data sources",
    extendedLink: "/customers/sanofi/"
  }, {
    company: "smartcar",
    text: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: "\u201CBuilding a user-friendly API isn\u2019t always easy\u2014especially if you want to appeal to your users and their users. Thanks to Twilio Segment, we can focus on both areas in one go, and give our team the chance to measure and evaluate the things they feel are most important.\u201D"
    }),
    name: "Sanketh Katta",
    position: "CTO and co-founder, Smartcar",
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* SmartcarMonoLogo */.DXF, {
      color: theme.palette.twilio.gray[70]
    }),
    logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* SmartcarLogo */.GQ7, {}),
    logoName: "Smartcar",
    extendedRate: "22%",
    extendedText: "improvement in developer application conversions",
    extendedLink: "/customers/smartcar/"
  }, {
    company: "lens-online",
    text: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: "\u201CWhile our previous tech stack, including a CRM, SAP, Zendesk, etc. supported our early growth, it wasn't enough for our future ambitions. We needed to not just understand but anticipate our customer's needs. This realization led us to Twilio Segment, moving beyond traditional CRMs to a 360-degree view of customers, integrating every customer interaction and preference with a customer data platform.\u201D"
    }),
    name: "Pascal",
    position: "CMO & CDO, LensOnline",
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* LensOnlineMonoLogo */.FRf, {
      color: theme.palette.twilio.gray[70]
    }),
    logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* LensOnlineLogo */.vmS, {}),
    logoName: "Fender",
    extendedRate: "15%",
    extendedText: "reduction in marketing spend",
    extendedLink: "/customers/lens-online/"
  }];
};


;// CONCATENATED MODULE: ./src/views/UseCases/CustomerInsights/components/TestimonialsSlider/TestimonialsSlider.tsx


function TestimonialsSlider_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var TestimonialsSlider_copy = {
  heading: "Twilio Segment powers the world\u2019s leading brands",
  description: "From startups to global enterprises, see what businesses have achieved with the Twilio Segment customer data platform.",
  button: {
    text: "View more customer stories",
    href: "/customers/"
  }
};

var TestimonialsSlider = function TestimonialsSlider() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TestimonialsSlider_StyledSection, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h2",
          tag: "h2",
          children: TestimonialsSlider_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "pLarge",
          tag: "p",
          children: TestimonialsSlider_copy.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: "twilioDark",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TestimonialSlider["default"], {
        data: testimonialData,
        innerStyles: false,
        title: false
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
        variant: "outlined",
        size: "large",
        color: "primary",
        href: (0,getAbsoluteUrl/* default */.Z)(TestimonialsSlider_copy.button.href, pageConfig),
        children: TestimonialsSlider_copy.button.text
      })
    })]
  });
};

var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ef7opg31"
} : 0)( true ? {
  name: "54vf60",
  styles: "margin-top:-40px"
} : 0);

var TestimonialsSlider_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ef7opg30"
} : 0)( true ? {
  name: "etts4h",
  styles: "max-width:1260px;overflow-x:visible"
} : 0);

/* harmony default export */ var TestimonialsSlider_TestimonialsSlider = (TestimonialsSlider);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/components/Badge/index.ts + 2 modules
var Badge = __webpack_require__(16154);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/index.ts + 31 modules
var Card = __webpack_require__(74881);
;// CONCATENATED MODULE: ./src/views/UseCases/CustomerInsights/components/GetReady/GetReady.tsx


function GetReady_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var GetReady_copy = {
  heading: "Ready to enable customer insights and analytics?",
  data: [{
    tag: "Recipe",
    title: "Supercharge user profiles with ChatGPT and Twilio Segment: unlocking the power of personalization based on sentiment analysis",
    buttonText: "Read the recipe",
    href: "/recipes/personalize-with-chatgpt-and-segment-sentiment-analysis/"
  }, {
    tag: "Case study",
    title: "How global healthcare leader Sanofi uses Twilio Segment to build golden profiles, increase omni-channel engagement, and improve patient outcomes",
    buttonText: "Read the case study",
    href: "/customers/sanofi/"
  }, {
    tag: "Webinar",
    title: "No Code Required: CustomerAI Predictions in Action",
    buttonText: "Watch the webinar",
    href: "https://webinars.segment.com/segment/no-code-required-customerai-predictions-in-action"
  }]
};

var GetReady = function GetReady() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GetReady_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GetReady_StyledSection, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h2",
          tag: "h2",
          children: GetReady_copy.heading
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
          columns: 1,
          overrides: {
            md: 3
          },
          children: GetReady_copy.data.map(function (_ref, key) {
            var tag = _ref.tag,
                title = _ref.title,
                buttonText = _ref.buttonText,
                href = _ref.href;
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.ZP, {
              appearance: "twilioLight",
              href: (0,getAbsoluteUrl/* default */.Z)(href, pageConfig),
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Body */.uT, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Accessories */.v8, {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* AccessoriesRow */.OW, {
                    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
                      variant: "outlined",
                      children: tag
                    })
                  })
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Copy */.CK, {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Headline */.s0, {
                    tag: "h3",
                    variant: "h4",
                    children: title
                  })
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Action */.aU, {
                  alignment: "left",
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
                    iconEnd: Common/* ChevronRightIcon */.XC,
                    children: buttonText
                  })
                })]
              })
            }, key);
          })
        })
      })]
    })
  });
};

var GetReady_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eeca66a1"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.mint[10];
}, ";" + ( true ? "" : 0));

var GetReady_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "eeca66a0"
} : 0)( true ? {
  name: "1fygc5t",
  styles: "max-width:1280px"
} : 0);

/* harmony default export */ var GetReady_GetReady = (GetReady);
;// CONCATENATED MODULE: ./src/views/UseCases/CustomerInsights/components/LearnMore/LearnMore.tsx


function LearnMore_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var LearnMore_copy = {
  heading: "Learn more about customer insights and analytics with Segment",
  description: "Twilio Segment is a critical tool in your tech stack to enable customer insights and analytics. Connect with a Segment expert to learn more about why 25,000+ companies choose Segment's CDP."
};
var buttons = [{
  text: "Get a demo",
  href: "/demo",
  variant: "filled"
}, {
  text: "Pricing",
  href: "/pricing",
  variant: "outlined"
}];

var LearnMore = function LearnMore() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LearnMore_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LearnMore_StyledSection, {
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h2",
          tag: "h2",
          children: LearnMore_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDescription, {
          variant: "pLarge",
          tag: "p",
          children: LearnMore_copy.description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonGroup, {
          children: buttons.map(function (button) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
              variant: button.variant,
              size: "medium",
              color: "primary",
              href: (0,getAbsoluteUrl/* default */.Z)(button.href, pageConfig),
              children: button.text
            }, button.text);
          })
        })]
      })
    })
  });
};

var LearnMore_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebj42y3"
} : 0)("background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

var LearnMore_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ebj42y2"
} : 0)(Section/* Wrapper */.im, "{gap:0;}" + ( true ? "" : 0));

var StyledDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Description */.dk,  true ? {
  target: "ebj42y1"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);

var ButtonGroup = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebj42y0"
} : 0)( true ? {
  name: "j5xd9k",
  styles: "margin-top:30px;display:flex;align-items:center;gap:16px"
} : 0);

/* harmony default export */ var LearnMore_LearnMore = (LearnMore);
;// CONCATENATED MODULE: ./src/views/UseCases/CustomerInsights/CustomerInsights.tsx

















var CustomerInsights_copy = {
  pageTitle: "Get Customer Insights | Twilio Segment",
  pageDescription: "With clean, unified customer data, Twilio Segment can help you gain clear insights into your customer behavior, needs, and pain points."
};

var CustomerInsightsView = function CustomerInsightsView() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: CustomerInsights_copy.pageTitle,
      pageDescription: CustomerInsights_copy.pageDescription,
      bodyBackground: theme.palette.neutrals.white[100],
      themeColor: theme.palette.neutrals.white[100],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
        appearance: "twilioDark",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Hero_Hero, {})
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarouselWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel["default"], {})
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_DeepenUnderstanding_DeepenUnderstanding, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_SelfServeAnalytics_SelfServeAnalytics, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_DataScienceModeling_DataScienceModeling, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WhySegment_WhySegment, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TestimonialsSlider_TestimonialsSlider, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GetReady_GetReady, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LearnMore_LearnMore, {})]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
    })
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e1kqz9za1"
} : 0)( true ? "" : 0);

var LogoCarouselWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1kqz9za0"
} : 0)("padding:80px 0;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("md");
}, "{padding:40px 0;}" + ( true ? "" : 0));

/* harmony default export */ var CustomerInsights_CustomerInsights = (CustomerInsightsView);
;// CONCATENATED MODULE: ./src/pages/use-cases/customer-insights.tsx



var CustomerInsights = function CustomerInsights() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomerInsights_CustomerInsights, {});
};

/* harmony default export */ var customer_insights = (CustomerInsights);

/***/ }),

/***/ 96856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useLocation_useLocation; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/api/staticSiteBackend/client.ts + 2 modules
var client = __webpack_require__(39896);
;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/location.ts



var fetchLocation = function fetchLocation(client, signal) {
  return client.get("/location/", {
    signal: signal,
    headers: [["X-Backend-Api", String("KiBZKjNMR0k4ZX1pcGZjIG9fRnh3V14m")]]
  });
};

var fetchLocationCode = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(client, signal) {
    var code;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.get("/location/countryCode/", {
              signal: signal,
              headers: [["X-Backend-Api", String("KiBZKjNMR0k4ZX1pcGZjIG9fRnh3V14m")]]
            });

          case 2:
            code = _context.sent;
            return _context.abrupt("return", code.data);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchLocationCode(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();


;// CONCATENATED MODULE: ../../libs/api/utils/useLocation/useLocation.ts





/**
 * A hook that provides the country code of the user's location.
 * @returns The country code of the user's location.
 */

var useLocation = function useLocation() {
  var _useState = (0,react.useState)(""),
      code = _useState[0],
      setCode = _useState[1];

  var fetchData = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(signal) {
      var response;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetchLocationCode((0,client/* createClient */.e)(), signal);

            case 3:
              response = _context.sent;
              setCode(response.toLowerCase());
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              setCode("us");

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  (0,react.useEffect)(function () {
    var controller = new AbortController();
    fetchData(controller.signal);
    return function () {
      controller.abort();
    };
  }, [fetchData]);
  return code;
};

/* harmony default export */ var useLocation_useLocation = (useLocation);
;// CONCATENATED MODULE: ../../libs/api/utils/useLocation/index.ts


/***/ }),

/***/ 805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ DemoProvider; },
/* harmony export */   "d": function() { return /* binding */ DemoContext; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52903);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



var DemoContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
  completedFormData: undefined,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setCompletedFormData: function setCompletedFormData() {}
});
var DemoProvider = function DemoProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
    completedFormData: undefined,
    setCompletedFormData: function setCompletedFormData(value) {
      return setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          completedFormData: value
        });
      });
    }
  }),
      state = _useState[0],
      setState = _useState[1];

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(DemoContext.Provider, {
    value: state,
    children: children
  });
};

/***/ }),

/***/ 33514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Dx; },
/* harmony export */   "Hq": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Hq; },
/* harmony export */   "ZP": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Ob; },
/* harmony export */   "h4": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.h4; },
/* harmony export */   "uT": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.uT; },
/* harmony export */   "xv": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.xv; }
/* harmony export */ });
/* harmony import */ var _FeatureBox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13379);

_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .FeatureBox.displayName */ .Ob.displayName = "FeatureBoxBase";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Body.displayName */ .uT.displayName = "FeatureBox.Body";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Header.displayName */ .h4.displayName = "FeatureBox.Header";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Text.displayName */ .xv.displayName = "FeatureBox.Text";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Title.displayName */ .Dx.displayName = "FeatureBox.Title";


/***/ }),

/***/ 79600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ components_IconWrapper_IconWrapper; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ../../libs/matcha/components/IconWrapper/IconWrapper.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var IconWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1bo4d8j1"
} : 0)("width:44px;height:44px;border-radius:50%;color:", function (_ref2) {
  var color = _ref2.color;
  return color;
}, ";background-color:", function (_ref3) {
  var backgroundColor = _ref3.backgroundColor;
  return backgroundColor;
}, ";", function (_ref4) {
  var elevation = _ref4.elevation,
      theme = _ref4.theme;
  return elevation &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("box-shadow:", theme.shadows[elevation], ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));

var _ref =  true ? {
  name: "1iixa1j",
  styles: "width:40px;height:40px;svg{width:40px;height:40px;}padding:2px"
} : 0;

var Icon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1bo4d8j0"
} : 0)("display:block;width:24px;height:24px;padding:10px;", function (_ref5) {
  var variant = _ref5.variant;
  return variant === "transparent" && _ref;
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/IconWrapper/IconWrapper.tsx


var _excluded = ["tokens", "variant", "elevation", "className", "tag", "children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseIconWrapper = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var tokens = _ref.tokens,
      variant = _ref.variant,
      elevation = _ref.elevation,
      className = _ref.className,
      tag = _ref.tag,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper, _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    className: className,
    elevation: elevation,
    as: tag
  }, tokens), rest), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon, {
      variant: variant,
      children: children
    })
  }));
});

var getBackgroundPropTokens = function getBackgroundPropTokens(background, theme) {
  switch (background) {
    case "white":
      return {
        backgroundColor: theme.palette.neutrals.white[100],
        color: theme.palette.brand.boysenberry[500]
      };

    case "light":
      return {
        backgroundColor: theme.palette.brand.boysenberry[100],
        color: theme.palette.brand.darkAcai[700]
      };

    case "dark":
      return {
        backgroundColor: theme.palette.brand.darkAcai[600],
        color: theme.palette.brand.boysenberry[200]
      };

    default:
      return {
        backgroundColor: theme.palette.neutrals.white[100],
        color: theme.palette.twilio.gray[100]
      };
  }
};

var IconWrapper_IconWrapper = (0,useDesignTokens/* withDesignTokens */.Y)(BaseIconWrapper, function (_ref2) {
  var elevation = _ref2.elevation;
  return {
    elevation: elevation
  };
}, {
  light: function light(theme, props) {
    if (props.variant === "transparent") {
      return {
        color: theme.palette.brand.darkAcai[700],
        backgroundColor: "transparent"
      };
    }

    if (props.background) {
      return getBackgroundPropTokens(props.background, theme);
    }

    return {
      color: theme.palette.brand.darkAcai[700],
      backgroundColor: theme.palette.brand.boysenberry[100]
    };
  },
  dark: function dark(theme, props) {
    if (props.variant === "transparent") {
      return {
        color: theme.palette.neutrals.white[100],
        backgroundColor: "transparent"
      };
    }

    if (props.background) {
      return getBackgroundPropTokens(props.background, theme);
    }

    return {
      color: theme.palette.brand.boysenberry[200],
      backgroundColor: theme.palette.brand.darkAcai[600]
    };
  },
  twilioLight: function twilioLight(theme, props) {
    if (props.variant === "transparent") {
      return {
        color: theme.palette.twilio.gray[100],
        backgroundColor: "transparent"
      };
    }

    if (props.background) {
      return getBackgroundPropTokens(props.background, theme);
    }

    return {
      color: theme.palette.twilio.gray[100],
      backgroundColor: theme.palette.neutrals.white[100]
    };
  }
});
/* harmony default export */ var components_IconWrapper_IconWrapper = (IconWrapper_IconWrapper);
;// CONCATENATED MODULE: ../../libs/matcha/components/IconWrapper/index.ts


/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 77840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ FormSubmitMessage; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitMessage/data.tsx
var data = {
  success: {
    demo: {
      description: "Thank you for submitting your request for a demo! Answer 4 more questions to help us pinpoint exactly what your team needs to get started with Segment."
    }
  },
  error: {
    demo: {
      description: "We are really sorry. There was an error processing your submission. Try reloading your browser, and submitting again."
    }
  }
};
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitMessage/FormSubmitMessage.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10kq2lq3"
} : 0)("padding:32px;border:1px solid ", function (_ref) {
  var borderColor = _ref.borderColor;
  return borderColor;
}, ";border-radius:8px;text-align:left;" + ( true ? "" : 0));
var Header = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10kq2lq2"
} : 0)( true ? {
  name: "9qwgfz",
  styles: "display:grid;grid-auto-flow:column;grid-template-columns:max-content 1fr;align-items:center;gap:8px"
} : 0);
var StyledDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e10kq2lq1"
} : 0)( true ? {
  name: "172op4w",
  styles: "margin-top:0;margin-bottom:0"
} : 0);
var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e10kq2lq0"
} : 0)( true ? {
  name: "7ut0hf",
  styles: "margin:0;margin-bottom:16px"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitMessage/FormSubmitMessage.tsx


var _excluded = ["form", "status", "heading", "description", "tokens", "appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}








var BaseFormSubmitMessage = function BaseFormSubmitMessage(_ref) {
  var form = _ref.form,
      status = _ref.status,
      heading = _ref.heading,
      description = _ref.description,
      tokens = _ref.tokens,
      externalAppearance = _ref.appearance,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  var localData = form && data[status][form];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: appearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread(_objectSpread({}, tokens.wrapper), rest), {}, {
      children: [heading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
          variant: "h4",
          tag: "p",
          tokens: tokens.header,
          children: heading
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDescription, {
        variant: "pMedium",
        tokens: tokens.description,
        children: description || (localData === null || localData === void 0 ? void 0 : localData.description)
      })]
    }))
  });
};

var FormSubmitMessage = (0,useDesignTokens/* withDesignTokens */.Y)(BaseFormSubmitMessage, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.brand.darkAcai[300]
      },
      description: {
        color: theme.palette.brand.darkAcai[300]
      }
    };
  },
  light: function light(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.brand.darkAcai[300]
      },
      description: {
        color: theme.palette.brand.darkAcai[500]
      }
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.twilio.gray[30]
      },
      description: {
        color: theme.palette.twilio.gray[100]
      }
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.twilio.gray[30]
      },
      description: {
        color: theme.palette.neutrals.white[100]
      }
    };
  }
});
/* harmony default export */ var FormSubmitMessage_FormSubmitMessage = ((/* unused pure expression or super */ null && (FormSubmitMessage)));

/***/ }),

/***/ 98960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ DemoForm; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(88883);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/templates/FormFields/index.ts + 22 modules
var FormFields = __webpack_require__(53790);
// EXTERNAL MODULE: ../../libs/templates/Disclaimer/index.ts + 3 modules
var Disclaimer = __webpack_require__(80401);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitMessage/FormSubmitMessage.tsx + 2 modules
var FormSubmitMessage = __webpack_require__(77840);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitAction/index.ts + 2 modules
var FormSubmitAction = __webpack_require__(17433);
// EXTERNAL MODULE: ../../libs/templates/TrackableForm/index.ts + 5 modules
var TrackableForm = __webpack_require__(53100);
// EXTERNAL MODULE: ../../libs/tracking/scripts/helpers.ts
var helpers = __webpack_require__(753);
// EXTERNAL MODULE: ../../libs/api/utils/useLocation/index.ts + 2 modules
var useLocation = __webpack_require__(96856);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
// EXTERNAL MODULE: ../../libs/utils/regexes/sharedEmail.ts
var sharedEmail = __webpack_require__(13206);
// EXTERNAL MODULE: ../../libs/utils/regexes/email.ts
var email = __webpack_require__(36219);
// EXTERNAL MODULE: ../../libs/utils/regexes/form.ts
var regexes_form = __webpack_require__(63535);
// EXTERNAL MODULE: ../../libs/utils/regexes/lastName.ts
var lastName = __webpack_require__(51895);
;// CONCATENATED MODULE: ../../libs/utils/regexes/forbiddenEmail.ts
var customDomainList = ["@gmail.com", "@yahoo.com", "@hotmail.com", "@aol.com", "@hotmail.co.uk", "@hotmail.fr", "@msn.com", "@yahoo.fr", "@wanadoo.fr", "@orange.fr", "@comcast.net", "@yahoo.co.uk", "@yahoo.com.br", "@yahoo.co.in", "@live.com", "@rediffmail.com", "@free.fr", "@gmx.de", "@web.de", "@yandex.ru", "@ymail.com", "@libero.it", "@outlook.com", "@uol.com.br", "@bol.com.br", "@mail.ru", "@cox.net", "@hotmail.it", "@sbcglobal.net", "@sfr.fr", "@live.fr", "@verizon.net", "@live.co.uk", "@googlemail.com", "@yahoo.es", "@ig.com.br", "@live.nl", "@bigpond.com", "@terra.com.br", "@yahoo.it", "@neuf.fr", "@yahoo.de", "@alice.it", "@rocketmail.com", "@att.net", "@laposte.net", "@facebook.com", "@bellsouth.net", "@yahoo.in", "@hotmail.es", "@charter.net", "@yahoo.ca", "@yahoo.com.au", "@rambler.ru", "@hotmail.de", "@tiscali.it", "@shaw.ca", "@yahoo.co.jp", "@sky.com", "@earthlink.net", "@optonline.net", "@freenet.de", "@t-online.de", "@aliceadsl.fr", "@virgilio.it", "@home.nl", "@qq.com", "@telenet.be", "@me.com", "@yahoo.com.ar", "@tiscali.co.uk", "@yahoo.com.mx", "@voila.fr", "@gmx.net", "@mail.com", "@planet.nl", "@tin.it", "@live.it", "@ntlworld.com", "@arcor.de", "@yahoo.co.id", "@frontiernet.net", "@hetnet.nl", "@live.com.au", "@yahoo.com.sg", "@zonnet.nl", "@club-internet.fr", "@juno.com", "@optusnet.com.au", "@blueyonder.co.uk", "@bluewin.ch", "@skynet.be", "@sympatico.ca", "@windstream.net", "@mac.com", "@centurytel.net", "@chello.nl", "@live.ca", "@aim.com", "@bigpond.net.au", "@email.com", "@gmail", "@yahoo", "@hotmail", "@outlook", "@protonmail", "@gwk.com", "@free.", "@tutanota", "@gmx", "@mail2world", "@icloud", "@segment.com", "@.om", "@163.com", "@qq", "@gmai.com", "@yaoo.com", "@company.com", "@gail.com", "@abc.com", "@domain.com", "@gma.com", "@gnail.com", "@li.com", "@yah.com", "@5euros.com", "@business.com", "@emil.com", "@gaylord.info", "@gimal.com", "@gml.com", "@info.com", "@mailinator.com", "@w.com", "@yhoo.com", "@yo.com", "@0546876.com", "@10.com", "@101.gmail.com", "@11.com", "@12356gmail.com", "@123yahoo.com", "@175gmali.com", "@1servicesteamfrazier.com", "@2gmail.com", "@2ncad.com", "@365gmial.com", "@37.com", "@5024gmail.com", "@70gmail.com", "@72gmail.co.com", "@81gmail.com", "@8543g.mail.com", "@9085.gmail.com", "@9784.com", "@asdf.com", "@asdfas222334.com", "@asdsad.com", "@fuckyou.com", "@g.com", "@g.email", "@gamill.com", "@gimel.com", "@gl.com", "@gmaiil.com", "@gmaik.com", "@gmail-elif.com", "@gmail.com.pk", "@gmail.com120194", "@gmail.com4", "@gmaile.com", "@gmaill.com", "@gmaiol.com", "@gmaqil.com", "@gmaul.com", "@gmeel.come", "@gmil.comraj", "@gmsil.com", "@gmw.ere", "@gnail.con", "@haha.com", "@hahaha.com", "@il.co", "@il.com", "@test.cc", "@us.army.mil", "@ya.com", "@yaahoo.com", "@yahoo.coin", "@yho.com", "@yohoo.com", "@.aim", "@zoho", "@protonmail.com", "@mailinator", "@boutique1.com", "@bugfoo.com", "@duiter.com", "@fectode.com", "@gmial.com", "@jewelry.com", "@jims.net", "@jthoven.com", "@lolcorporate.com", "@naver.com", "@restaurant.com", "@stayclearbeauty.com", "@tem.com.my", "@thegymgroup.com", "@Marco.com"]; // Escape the dots in the domains, as they have a special meaning in regex

var escapedDomains = customDomainList.map(function (domain) {
  return domain.replace(/\./g, "\\.");
}); // Create the regex pattern using negative lookahead

var REGEX_PATTERN = "^(?!.*(".concat(escapedDomains.join("|"), ")).*$");
var forbiddenEmailRegex = new RegExp(REGEX_PATTERN, "i"); // Use the 'i' flag for case-insensitive matching

/* harmony default export */ var forbiddenEmail = (forbiddenEmailRegex);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Forms/ProgressiveProfileForm/ProgressiveProfileForm.tsx + 2 modules
var ProgressiveProfileForm = __webpack_require__(6612);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Forms/DemoForm/DemoForm.views.tsx

var FormWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dszmc2"
} : 0)( true ? "" : 0);
var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dszmc1"
} : 0)( true ? "" : 0);
var DisclaimerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dszmc0"
} : 0)( true ? "" : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Forms/DemoForm/DemoForm.tsx


var _excluded = ["appearance", "className", "before", "after", "isProgressive", "isLeadEnrichmentFormEnabled", "overrideConsent", "customFormIdentifier", "customTrackingType", "successMessageAppearance", "onEmailCompleted", "buttonText", "customDisclaimer", "driftCampaignId", "successMessage"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
/* eslint-disable react-hooks/exhaustive-deps */





























var MOBILE_OFFSET = -150;
var DESKTOP_OFFSET = -350;
var FORM_ID = "demo-form"; // Set up demo form props since we define some of these props here in the template

var DemoForm = function DemoForm(_ref) {
  var appearance = _ref.appearance,
      className = _ref.className,
      before = _ref.before,
      after = _ref.after,
      _ref$isProgressive = _ref.isProgressive,
      isProgressive = _ref$isProgressive === void 0 ? false : _ref$isProgressive,
      _ref$isLeadEnrichment = _ref.isLeadEnrichmentFormEnabled,
      isLeadEnrichmentFormEnabled = _ref$isLeadEnrichment === void 0 ? true : _ref$isLeadEnrichment,
      _ref$overrideConsent = _ref.overrideConsent,
      overrideConsent = _ref$overrideConsent === void 0 ? true : _ref$overrideConsent,
      customFormIdentifier = _ref.customFormIdentifier,
      customTrackingType = _ref.customTrackingType,
      successMessageAppearance = _ref.successMessageAppearance,
      onEmailCompleted = _ref.onEmailCompleted,
      _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? "Get a demo" : _ref$buttonText,
      customDisclaimer = _ref.customDisclaimer,
      driftCampaignId = _ref.driftCampaignId,
      customSuccessMessage = _ref.successMessage,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _usePageConfig = (0,page/* usePageConfig */.Gm)(),
      baseUrl = _usePageConfig.baseUrl;

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var formAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var countryCode = (0,useLocation/* default */.Z)(); // Initialize form here since we need the form initialized to handle progressive fields and the personal email functionality

  var _useState = (0,react.useState)(false),
      emailCompleted = _useState[0],
      setEmailCompleted = _useState[1];

  var _useState2 = (0,react.useState)(undefined),
      intPhoneErrorCode = _useState2[0],
      setIntPhoneErrorCode = _useState2[1];

  var _useState3 = (0,react.useState)(),
      submittedEmail = _useState3[0],
      setSubmittedEmail = _useState3[1];
  /* eslint-disable camelcase */


  var schema = (0,react.useMemo)(function () {
    var _z$object;

    return lib/* object */.Ry((_z$object = {
      email: lib/* string */.Z_({
        required_error: FormFields/* companyEmailMessages.required */.BN.required
      }).regex(regexes_form/* default */.Z, {
        message: FormFields/* companyEmailMessages.invalid */.BN.invalid
      }).regex(email/* default */.Z, {
        message: FormFields/* companyEmailMessages.invalid */.BN.invalid
      })
      /* This is equal to .email( { message: companyEmailMessages.invalid }) but with a custom regex */
      .regex(sharedEmail/* default */.C, {
        message: FormFields/* companyEmailMessages.invalid */.BN.invalid
      }).regex(forbiddenEmail, {
        message: FormFields/* companyEmailMessages.forbiddenEmail */.BN.forbiddenEmail
      }),
      name: lib/* string */.Z_({
        required_error: FormFields/* fullNameMessages.required */.aZ.required
      }).regex(regexes_form/* default */.Z, {
        message: FormFields/* fullNameMessages.invalid */.aZ.invalid
      }).regex(lastName/* default */.Z, {
        message: FormFields/* fullNameMessages.invalid */.aZ.invalid
      }),
      phone: lib/* string */.Z_({
        invalid_type_error: FormFields/* phoneNumberMessages.invalid */.NJ.invalid
      }).min(1, FormFields/* phoneNumberMessages.required */.NJ.required).refine(function () {
        return intPhoneErrorCode === undefined;
      }, {
        message: (0,FormFields/* getPhoneErrorMessage */.AP)(intPhoneErrorCode)
      })
    }, (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_VALID_FIELD */.tj, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_ERRORS_FIELD */.q5, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_CALLING_COUNTRY_CODE */.iZ, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_COUNTRY_CODE */.$l, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_NUMBER */.SZ, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_NATIONAL_FORMAT */.UN, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, "company", lib/* string */.Z_({
      required_error: FormFields/* companyNameMessages.required */.qx.required
    }).regex(regexes_form/* default */.Z, {
      message: FormFields/* companyNameMessages.invalid */.qx.invalid
    })), _z$object));
  }, [intPhoneErrorCode]);
  /* eslint-enable camelcase */

  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUnregister: true,
    resolver: (0,zod/* zodResolver */.F)(schema)
  }); // Watch for personal email

  var watchedEmail = methods === null || methods === void 0 ? void 0 : methods.watch("email", ""); // If this is the progressive version of the form, set up email watching
  // Otherwise just always return true

  var showProgressiveFields = isProgressive ? Boolean(watchedEmail || emailCompleted) : true; // Mobile breakpoints

  var mobileResolutionMediaQuery = theme.breakpoints.down("md", false);
  var isSmallResolution = (0,useMatchMedia/* default */.Z)(mobileResolutionMediaQuery, true);
  (0,react.useEffect)(function () {
    if (watchedEmail) {
      setEmailCompleted(true);
      if (onEmailCompleted) onEmailCompleted();
    }
  }, [watchedEmail]);
  var successMessage = customSuccessMessage || {
    heading: "Thank you, you\u2019re all set!",
    description: "We'll get back to you shortly. For now, you can create your workspace by clicking below.",
    buttonUrl: "".concat(baseUrl, "/signup/?utm_campaign=demo"),
    buttonText: "Create your free workspace"
  };

  var collectDriftFormData = function collectDriftFormData(formData) {
    var unTypedWindow = window;

    if (unTypedWindow.drift) {
      unTypedWindow.drift.api.collectFormData(_objectSpread(_objectSpread({}, formData), {}, {
        firstName: formData.name.split(" ")[0],
        lastName: formData.name.split(" ").slice(1).join(" ")
      }), {
        campaignId: driftCampaignId
      });
    }
  };

  (0,react.useEffect)(function () {
    if (methods.getValues("phone")) {
      methods.trigger("phone");
    }
  }, [intPhoneErrorCode]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: formAppearance,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormWrapper, {
      id: FORM_ID,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrackableForm/* default */.Z, _objectSpread(_objectSpread({
        gap: "small",
        methods: methods,
        className: className,
        before: before,
        after: after,
        success: isLeadEnrichmentFormEnabled ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {}) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, _objectSpread({
          form: "demo",
          status: "success",
          appearance: successMessageAppearance,
          "data-hook": "demo-signup-success-message"
        }, successMessage)),
        error: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, _objectSpread({
          form: "demo",
          status: "error",
          "data-hook": "demo-form-error-message"
        }, TrackableForm/* errorMessage */.N)),
        onSubmit: function onSubmit(data) {
          setSubmittedEmail(data.email);
          (0,helpers/* createDemoLead */.Ii)(data);

          if (driftCampaignId) {
            collectDriftFormData(data);
          }

          if (isSmallResolution && showProgressiveFields) {
            (0,useScrollToAnchor/* scrollToAnchor */.d)(FORM_ID, MOBILE_OFFSET, false);
          } else {
            (0,useScrollToAnchor/* scrollToAnchor */.d)(FORM_ID, DESKTOP_OFFSET, false);
          }
        },
        onFailure: helpers/* trackValidationErrorDemoForm */.nR,
        overrideConsent: overrideConsent,
        customFormIdentifier: customFormIdentifier,
        customTrackingType: customTrackingType
      }, rest), {}, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CompanyEmailField */.Ot, {
          onBlur: helpers/* trackValidationErrorDemoForm */.nR
        }), showProgressiveFields && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* FullNameField */.AM, {
            onBlur: helpers/* trackValidationErrorDemoForm */.nR
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* PhoneNumberField */.g8, {
            countryCode: countryCode,
            onValidate: setIntPhoneErrorCode,
            onBlur: helpers/* trackValidationErrorDemoForm */.nR
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CompanyNameField */.wA, {
            onBlur: helpers/* trackValidationErrorDemoForm */.nR
          })]
        }), customFormIdentifier && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CustomFormIdentifierField */.Fe, {
          value: customFormIdentifier
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            color: "primary",
            variant: "filled",
            size: "large",
            expanded: true,
            children: buttonText
          })
        }), showProgressiveFields && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DisclaimerWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Disclaimer/* default */.Z, {
            data: customDisclaimer,
            appearance: successMessageAppearance
          })
        })]
      }))
    }), isLeadEnrichmentFormEnabled && methods.formState.isSubmitSuccessful && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProgressiveProfileForm/* ProgressiveProfileForm */.u, {
      before: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitMessage/* FormSubmitMessage */.f, {
        status: "success",
        form: "demo"
      }),
      email: submittedEmail,
      successMessage: successMessage
    })]
  });
};
/* harmony default export */ var DemoForm_DemoForm = ((/* unused pure expression or super */ null && (DemoForm)));
;// CONCATENATED MODULE: ../../libs/templates/Forms/DemoForm/index.ts


/***/ }),

/***/ 6612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ ProgressiveProfileForm; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(88883);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/templates/FormFields/index.ts + 22 modules
var FormFields = __webpack_require__(53790);
// EXTERNAL MODULE: ../../libs/templates/Disclaimer/index.ts + 3 modules
var Disclaimer = __webpack_require__(80401);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitAction/index.ts + 2 modules
var FormSubmitAction = __webpack_require__(17433);
// EXTERNAL MODULE: ../../libs/templates/FormFields/JobTitle.tsx
var JobTitle = __webpack_require__(96321);
// EXTERNAL MODULE: ../../libs/templates/FormFields/Timeline.tsx
var Timeline = __webpack_require__(12307);
// EXTERNAL MODULE: ../../libs/templates/FormFields/MonthlyTraffic.tsx
var MonthlyTraffic = __webpack_require__(75886);
// EXTERNAL MODULE: ../../libs/templates/FormFields/CompanySize.tsx
var CompanySize = __webpack_require__(20417);
// EXTERNAL MODULE: ../../libs/matcha/components/Input/index.ts + 2 modules
var Input = __webpack_require__(94261);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/FormFields/HiddenEmail.tsx


var _excluded = ["type", "name", "id", "className", "dataHook", "value"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




/**
 * Email hidden input for demo forms
 */

var HiddenEmailField = function HiddenEmailField(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "hidden" : _ref$type,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "email" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "email" : _ref$id,
      className = _ref.className,
      dataHook = _ref.dataHook,
      value = _ref.value,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, _objectSpread(_objectSpread({
    "data-testid": "email",
    className: className,
    id: id,
    type: type,
    "data-hook": dataHook,
    value: value
  }, register(name, {})), rest));
};
// EXTERNAL MODULE: ../../libs/templates/TrackableForm/index.ts + 5 modules
var TrackableForm = __webpack_require__(53100);
// EXTERNAL MODULE: ../../libs/tracking/scripts/helpers.ts
var helpers = __webpack_require__(753);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
// EXTERNAL MODULE: ../../libs/utils/regexes/form.ts
var regexes_form = __webpack_require__(63535);
// EXTERNAL MODULE: ../../libs/contexts/demo.tsx
var demo = __webpack_require__(805);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Forms/ProgressiveProfileForm/ProgressiveProfileForm.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var FormWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebdrtja1"
} : 0)( true ? {
  name: "1flj9lk",
  styles: "text-align:left"
} : 0);
var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebdrtja0"
} : 0)( true ? "" : 0);
;// CONCATENATED MODULE: ../../libs/templates/Forms/ProgressiveProfileForm/ProgressiveProfileForm.tsx



var ProgressiveProfileForm_excluded = ["appearance", "className", "before", "after", "overrideConsent", "customFormIdentifier", "successMessageAppearance", "email", "successMessage"];


function ProgressiveProfileForm_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function ProgressiveProfileForm_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ProgressiveProfileForm_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProgressiveProfileForm_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
























var BUTTON_TEXT = "Let's get started";
/* eslint-disable camelcase */

var schema = lib/* object */.Ry({
  jobTitle: lib/* string */.Z_({
    required_error: JobTitle/* jobTitleMessages.required */.cY.required
  }).regex(regexes_form/* default */.Z, {
    message: JobTitle/* jobTitleMessages.invalid */.cY.invalid
  }),
  companySize: lib/* string */.Z_({
    required_error: CompanySize/* companySizeMessages.required */.CF.required
  }),
  monthlyTraffic: lib/* string */.Z_({
    required_error: MonthlyTraffic/* monthlyTrafficMessages.required */.dn.required
  }),
  timeline: lib/* string */.Z_({
    required_error: Timeline/* timelineMessages.required */.Cb.required
  }),
  email: lib/* string */.Z_().optional()
});
/* eslint-enable camelcase */
// Set up demo form props since we define some of these props here in the template

var ProgressiveProfileForm = function ProgressiveProfileForm(_ref) {
  var appearance = _ref.appearance,
      className = _ref.className,
      before = _ref.before,
      after = _ref.after,
      _ref$overrideConsent = _ref.overrideConsent,
      overrideConsent = _ref$overrideConsent === void 0 ? true : _ref$overrideConsent,
      customFormIdentifier = _ref.customFormIdentifier,
      successMessageAppearance = _ref.successMessageAppearance,
      email = _ref.email,
      customSuccessMessage = _ref.successMessage,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, ProgressiveProfileForm_excluded);

  var _usePageConfig = (0,page/* usePageConfig */.Gm)(),
      baseUrl = _usePageConfig.baseUrl;

  var formAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var scrollTo = (0,useScrollToAnchor/* default */.Z)("progressive-profile-form", -200);

  var _useContext = (0,react.useContext)(demo/* DemoContext */.d),
      setCompletedFormData = _useContext.setCompletedFormData; // Initialize form here since we need the form initialized to handle progressive fields and the personal email functionality


  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUnregister: true,
    resolver: (0,zod/* zodResolver */.F)(schema)
  });
  var successMessage = customSuccessMessage || {
    heading: "Thank you, you\u2019re all set!",
    description: "We'll get back to you shortly. For now, you can create your workspace by clicking below.",
    buttonUrl: "".concat(baseUrl, "/signup/?utm_campaign=demo"),
    buttonText: "Create your free workspace"
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: formAppearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormWrapper, {
      id: "progressive-profile-form",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrackableForm/* default */.Z, ProgressiveProfileForm_objectSpread(ProgressiveProfileForm_objectSpread({
        gap: "small",
        methods: methods,
        className: className,
        before: before,
        after: after,
        success: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, ProgressiveProfileForm_objectSpread({
          form: "demo",
          status: "success",
          appearance: successMessageAppearance,
          "data-hook": "demo-signup-success-message",
          onButtonClick: function onButtonClick() {
            (0,helpers/* trackButtonClick */.kO)({
              buttonText: successMessage.buttonText,
              buttonId: "Workspace signup",
              targetUrl: successMessage.buttonUrl
            });
          }
        }, successMessage)),
        error: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, ProgressiveProfileForm_objectSpread({
          status: "error"
        }, TrackableForm/* errorMessage */.N)),
        onSubmit: /*#__PURE__*/function () {
          var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
            return regenerator_default().wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    setCompletedFormData(data);
                    _context.next = 3;
                    return (0,helpers/* trackProgressiveProfileForm */.NX)(data);

                  case 3:
                    scrollTo();

                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }(),
        onFailure: helpers/* trackValidationErrorProgressiveProfileForm */.An,
        overrideConsent: overrideConsent,
        customFormIdentifier: customFormIdentifier
      }, rest), {}, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(JobTitle/* JobTitleField */.kL, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanySize/* CompanySizeSelectField */.BQ, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MonthlyTraffic/* MonthlyTrafficSelectField */.VW, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Timeline/* TimelineSelectField */.fz, {}), customFormIdentifier && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CustomFormIdentifierField */.Fe, {
          value: customFormIdentifier
        }), email && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HiddenEmailField, {
          value: email
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            color: "primary",
            variant: "filled",
            size: "large",
            expanded: true,
            children: BUTTON_TEXT
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Disclaimer/* default */.Z, {
          appearance: successMessageAppearance
        })]
      }))
    })
  });
};
/* harmony default export */ var ProgressiveProfileForm_ProgressiveProfileForm = ((/* unused pure expression or super */ null && (ProgressiveProfileForm)));

/***/ }),

/***/ 6087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ LogoCarousel_LogoCarousel; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/recipes/LogoCarousel/index.ts + 8 modules
var LogoCarousel = __webpack_require__(74595);
// EXTERNAL MODULE: ../../libs/templates/LogoCarousel/data.tsx
var data = __webpack_require__(43787);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/LogoCarousel/LogoCarousel.tsx


var _excluded = ["heading", "logos", "appearance", "headingVariant"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var getDefaultLogos = function getDefaultLogos(logosMap) {
  return [logosMap.DIGITAL_OCEAN, logosMap.IBM, logosMap.DOMINOS, logosMap.ANHEUSER_BUSCH, logosMap.VMWARE, logosMap.LEVIS, logosMap.LOG_ME_IN, logosMap.CLEAR_SCORE, logosMap.VACASA, logosMap.STAPLES, logosMap.INTUIT, logosMap.THE_SKIMM, logosMap.DRIFT, logosMap.ALLERGAN, logosMap.GLOSSIER, logosMap.AB_IN_BEV];
};

var LogoCarouselTemplate = function LogoCarouselTemplate(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Join the 25,000+ companies using the Segment platform" : _ref$heading,
      externalLogos = _ref.logos,
      externalAppearance = _ref.appearance,
      headingVariant = _ref.headingVariant,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  var finalLogos = externalLogos !== null && externalLogos !== void 0 ? externalLogos : getDefaultLogos(appearance === "twilioLight" ? data/* carouselLogos */.j : data/* carouselLogosMono */.G);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LogoCarousel/* default */.ZP, _objectSpread(_objectSpread({}, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel/* Heading */.X6, {
      variant: headingVariant,
      children: heading
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel/* LogoTrack */.xS, {
      icons: finalLogos
    })]
  }));
};

/* harmony default export */ var LogoCarousel_LogoCarousel = (LogoCarouselTemplate);
;// CONCATENATED MODULE: ../../libs/templates/LogoCarousel/index.ts


/***/ }),

/***/ 51895:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var lastName = /^(?![\s\S]*\s[;,?=+\-@])[^;,?=+\-@\s][\s\S]+$/g;
/* harmony default export */ __webpack_exports__["Z"] = (lastName);

/***/ }),

/***/ 63319:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/customer-insights",
      function () {
        return __webpack_require__(60574);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var useInterval = function (callback, delay) {
    var savedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(function () { });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        savedCallback.current = callback;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (delay !== null) {
            var interval_1 = setInterval(function () { return savedCallback.current(); }, delay || 0);
            return function () { return clearInterval(interval_1); };
        }
        return undefined;
    }, [delay]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useInterval);


/***/ }),

/***/ 92888:
/***/ (function(module) {

module.exports = "/_next/static/images/DataScienceModeling-60fec2d43c65d7c79b0bb6c650a7f1ba.png";

/***/ }),

/***/ 96820:
/***/ (function(module) {

module.exports = "/_next/static/images/DeepenUnderstanding@2x-eb37f07ea7eecef44c704f6a61333c1e.png";

/***/ }),

/***/ 99673:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-75b0cda4d30e7977e861bfef3436cc44.png";

/***/ }),

/***/ 57394:
/***/ (function(module) {

module.exports = "/_next/static/images/SelfServeAnalytics-95a3c0dffe2c1e21422e7ee722c2296c.png";

/***/ }),

/***/ 55592:
/***/ (function(module) {

module.exports = "/_next/static/images/DataScienceModeling-b25ed3c403eae932c1de263dcd72694d.webp";

/***/ }),

/***/ 63735:
/***/ (function(module) {

module.exports = "/_next/static/images/DataScienceModeling@2x-68fd48a7f8345d48230b31448eb6c397.webp";

/***/ }),

/***/ 99:
/***/ (function(module) {

module.exports = "/_next/static/images/DeepenUnderstanding-4d9ca3ce867ef8d0d048eba57f61357e.webp";

/***/ }),

/***/ 69593:
/***/ (function(module) {

module.exports = "/_next/static/images/DeepenUnderstanding@2x-11b556ab1c3f20929b7708ec5ba4e3a1.webp";

/***/ }),

/***/ 2461:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-3e5d260324c21b0dcb2a828c8cbd312f.webp";

/***/ }),

/***/ 1346:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-6c07948b2fdc59c0774a9aacea67b8e1.webp";

/***/ }),

/***/ 61614:
/***/ (function(module) {

module.exports = "/_next/static/images/SelfServeAnalytics-4c2b4304c760ec786a718b37c22c256e.webp";

/***/ }),

/***/ 75536:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ useAnimation; }
});

// EXTERNAL MODULE: ../../node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(41412);
// EXTERNAL MODULE: ../../node_modules/hey-listen/dist/hey-listen.es.js
var hey_listen_es = __webpack_require__(9340);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/utils/animation.mjs
var animation = __webpack_require__(59413);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/utils/setters.mjs + 3 modules
var setters = __webpack_require__(18617);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/animation-controls.mjs





/**
 * @public
 */
function animationControls() {
    /**
     * Track whether the host component has mounted.
     */
    var hasMounted = false;
    /**
     * Pending animations that are started before a component is mounted.
     * TODO: Remove this as animations should only run in effects
     */
    var pendingAnimations = [];
    /**
     * A collection of linked component animation controls.
     */
    var subscribers = new Set();
    var controls = {
        subscribe: function (visualElement) {
            subscribers.add(visualElement);
            return function () { return void subscribers.delete(visualElement); };
        },
        start: function (definition, transitionOverride) {
            /**
             * TODO: We only perform this hasMounted check because in Framer we used to
             * encourage the ability to start an animation within the render phase. This
             * isn't behaviour concurrent-safe so when we make Framer concurrent-safe
             * we can ditch this.
             */
            if (hasMounted) {
                var animations_1 = [];
                subscribers.forEach(function (visualElement) {
                    animations_1.push((0,animation/* animateVisualElement */.d5)(visualElement, definition, {
                        transitionOverride: transitionOverride,
                    }));
                });
                return Promise.all(animations_1);
            }
            else {
                return new Promise(function (resolve) {
                    pendingAnimations.push({
                        animation: [definition, transitionOverride],
                        resolve: resolve,
                    });
                });
            }
        },
        set: function (definition) {
            (0,hey_listen_es/* invariant */.k)(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            return subscribers.forEach(function (visualElement) {
                (0,setters/* setValues */.gg)(visualElement, definition);
            });
        },
        stop: function () {
            subscribers.forEach(function (visualElement) {
                (0,animation/* stopAnimation */.p_)(visualElement);
            });
        },
        mount: function () {
            hasMounted = true;
            pendingAnimations.forEach(function (_a) {
                var animation = _a.animation, resolve = _a.resolve;
                controls.start.apply(controls, (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(animation), false)).then(resolve);
            });
            return function () {
                hasMounted = false;
                controls.stop();
            };
        },
    };
    return controls;
}



// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(3105);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/use-animation.mjs




/**
 * Creates `AnimationControls`, which can be used to manually start, stop
 * and sequence animations on one or more components.
 *
 * The returned `AnimationControls` should be passed to the `animate` property
 * of the components you want to animate.
 *
 * These components can then be animated with the `start` method.
 *
 * ```jsx
 * import * as React from 'react'
 * import { motion, useAnimation } from 'framer-motion'
 *
 * export function MyComponent(props) {
 *    const controls = useAnimation()
 *
 *    controls.start({
 *        x: 100,
 *        transition: { duration: 0.5 },
 *    })
 *
 *    return <motion.div animate={controls} />
 * }
 * ```
 *
 * @returns Animation controller with `start` and `stop` methods
 *
 * @public
 */
function useAnimation() {
    var controls = (0,use_constant/* useConstant */.h)(animationControls);
    (0,react.useEffect)(controls.mount, []);
    return controls;
}




/***/ }),

/***/ 66057:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ useElementScroll; }
/* harmony export */ });
/* harmony import */ var _utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3105);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7622);
/* harmony import */ var _events_use_dom_event_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27723);
/* harmony import */ var _utils_use_isomorphic_effect_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23617);
/* harmony import */ var hey_listen__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9340);






var getElementScrollOffsets = function (element) { return function () {
    return {
        xOffset: element.scrollLeft,
        yOffset: element.scrollTop,
        xMaxOffset: element.scrollWidth - element.offsetWidth,
        yMaxOffset: element.scrollHeight - element.offsetHeight,
    };
}; };
/**
 * Returns MotionValues that update when the provided element scrolls:
 *
 * - `scrollX` — Horizontal scroll distance in pixels.
 * - `scrollY` — Vertical scroll distance in pixels.
 * - `scrollXProgress` — Horizontal scroll progress between `0` and `1`.
 * - `scrollYProgress` — Vertical scroll progress between `0` and `1`.
 *
 * This element must be set to `overflow: scroll` on either or both axes to report scroll offset.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const ref = useRef()
 *   const { scrollYProgress } = useElementScroll(ref)
 *
 *   return (
 *     <div ref={ref}>
 *       <motion.div style={{ scaleX: scrollYProgress }} />
 *     </div>
 *   )
 * }
 * ```
 *
 * @public
 */
function useElementScroll(ref) {
    var values = (0,_utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_0__/* .useConstant */ .h)(_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .createScrollMotionValues */ .w);
    (0,_utils_use_isomorphic_effect_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useIsomorphicLayoutEffect */ .L)(function () {
        var element = ref.current;
        (0,hey_listen__WEBPACK_IMPORTED_MODULE_3__/* .invariant */ .k)(!!element, "ref provided to useScroll must be passed into a HTML element.");
        if (!element)
            return;
        var updateScrollValues = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .createScrollUpdater */ .S)(values, getElementScrollOffsets(element));
        var scrollListener = (0,_events_use_dom_event_mjs__WEBPACK_IMPORTED_MODULE_4__/* .addDomEvent */ .E)(element, "scroll", updateScrollValues);
        var resizeListener = (0,_events_use_dom_event_mjs__WEBPACK_IMPORTED_MODULE_4__/* .addDomEvent */ .E)(element, "resize", updateScrollValues);
        return function () {
            scrollListener && scrollListener();
            resizeListener && resizeListener();
        };
    }, []);
    return values;
}




/***/ }),

/***/ 7622:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ createScrollUpdater; },
/* harmony export */   "w": function() { return /* binding */ createScrollMotionValues; }
/* harmony export */ });
/* harmony import */ var _index_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40226);


function createScrollMotionValues() {
    return {
        scrollX: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
        scrollY: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
        scrollXProgress: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
        scrollYProgress: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
    };
}
function setProgress(offset, maxOffset, value) {
    value.set(!offset || !maxOffset ? 0 : offset / maxOffset);
}
function createScrollUpdater(values, getOffsets) {
    var update = function () {
        var _a = getOffsets(), xOffset = _a.xOffset, yOffset = _a.yOffset, xMaxOffset = _a.xMaxOffset, yMaxOffset = _a.yMaxOffset;
        // Set absolute positions
        values.scrollX.set(xOffset);
        values.scrollY.set(yOffset);
        // Set 0-1 progress
        setProgress(xOffset, xMaxOffset, values.scrollXProgress);
        setProgress(yOffset, yMaxOffset, values.scrollYProgress);
    };
    update();
    return update;
}




/***/ }),

/***/ 77014:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useCombineMotionValues; }
/* harmony export */ });
/* harmony import */ var _use_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21687);
/* harmony import */ var _use_on_change_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29709);
/* harmony import */ var framesync__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76432);




function useCombineMotionValues(values, combineValues) {
    /**
     * Initialise the returned motion value. This remains the same between renders.
     */
    var value = (0,_use_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useMotionValue */ .c)(combineValues());
    /**
     * Create a function that will update the template motion value with the latest values.
     * This is pre-bound so whenever a motion value updates it can schedule its
     * execution in Framesync. If it's already been scheduled it won't be fired twice
     * in a single frame.
     */
    var updateValue = function () { return value.set(combineValues()); };
    /**
     * Synchronously update the motion value with the latest values during the render.
     * This ensures that within a React render, the styles applied to the DOM are up-to-date.
     */
    updateValue();
    /**
     * Subscribe to all motion values found within the template. Whenever any of them change,
     * schedule an update.
     */
    (0,_use_on_change_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useMultiOnChange */ .f)(values, function () { return framesync__WEBPACK_IMPORTED_MODULE_0__/* ["default"].update */ .ZP.update(updateValue, false, true); });
    return value;
}




/***/ }),

/***/ 85770:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useMotionTemplate; }
/* harmony export */ });
/* harmony import */ var _use_combine_values_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77014);


/**
 * Combine multiple motion values into a new one using a string template literal.
 *
 * ```jsx
 * import {
 *   motion,
 *   useSpring,
 *   useMotionValue,
 *   useMotionTemplate
 * } from "framer-motion"
 *
 * function Component() {
 *   const shadowX = useSpring(0)
 *   const shadowY = useMotionValue(0)
 *   const shadow = useMotionTemplate`drop-shadow(${shadowX}px ${shadowY}px 20px rgba(0,0,0,0.3))`
 *
 *   return <motion.div style={{ filter: shadow }} />
 * }
 * ```
 *
 * @public
 */
function useMotionTemplate(fragments) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    /**
     * Create a function that will build a string from the latest motion values.
     */
    var numFragments = fragments.length;
    function buildValue() {
        var output = "";
        for (var i = 0; i < numFragments; i++) {
            output += fragments[i];
            var value = values[i];
            if (value)
                output += values[i].get();
        }
        return output;
    }
    return (0,_use_combine_values_mjs__WEBPACK_IMPORTED_MODULE_0__/* .useCombineMotionValues */ .N)(values, buildValue);
}




/***/ }),

/***/ 21687:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useMotionValue; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41412);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _index_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40226);
/* harmony import */ var _context_MotionConfigContext_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60976);
/* harmony import */ var _utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3105);






/**
 * Creates a `MotionValue` to track the state and velocity of a value.
 *
 * Usually, these are created automatically. For advanced use-cases, like use with `useTransform`, you can create `MotionValue`s externally and pass them into the animated component via the `style` prop.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const scale = useMotionValue(1)
 *
 *   return <motion.div style={{ scale }} />
 * }
 * ```
 *
 * @param initial - The initial state.
 *
 * @public
 */
function useMotionValue(initial) {
    var value = (0,_utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useConstant */ .h)(function () { return (0,_index_mjs__WEBPACK_IMPORTED_MODULE_2__/* .motionValue */ .B)(initial); });
    /**
     * If this motion value is being used in static mode, like on
     * the Framer canvas, force components to rerender when the motion
     * value is updated.
     */
    var isStatic = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_MotionConfigContext_mjs__WEBPACK_IMPORTED_MODULE_3__/* .MotionConfigContext */ ._).isStatic;
    if (isStatic) {
        var _a = (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__read */ .CR)((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initial), 2), setLatest_1 = _a[1];
        (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () { return value.onChange(setLatest_1); }, []);
    }
    return value;
}




/***/ }),

/***/ 29709:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useMultiOnChange; },
/* harmony export */   "p": function() { return /* binding */ useOnChange; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _utils_is_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15815);



function useOnChange(value, callback) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if ((0,_utils_is_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__/* .isMotionValue */ .i)(value))
            return value.onChange(callback);
    }, [callback]);
}
function useMultiOnChange(values, handler) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var subscriptions = values.map(function (value) { return value.onChange(handler); });
        return function () { return subscriptions.forEach(function (unsubscribe) { return unsubscribe(); }); };
    });
}




/***/ }),

/***/ 29682:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ useTransform; }
});

// EXTERNAL MODULE: ../../node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(41412);
// EXTERNAL MODULE: ../../node_modules/popmotion/dist/es/utils/interpolate.mjs + 3 modules
var interpolate = __webpack_require__(1560);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/utils/transform.mjs



var isCustomValueType = function (v) {
    return typeof v === "object" && v.mix;
};
var getMixer = function (v) { return (isCustomValueType(v) ? v.mix : undefined); };
function transform() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var useImmediate = !Array.isArray(args[0]);
    var argOffset = useImmediate ? 0 : -1;
    var inputValue = args[0 + argOffset];
    var inputRange = args[1 + argOffset];
    var outputRange = args[2 + argOffset];
    var options = args[3 + argOffset];
    var interpolator = (0,interpolate/* interpolate */.s)(inputRange, outputRange, (0,tslib_es6/* __assign */.pi)({ mixer: getMixer(outputRange[0]) }, options));
    return useImmediate ? interpolator(inputValue) : interpolator;
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/use-combine-values.mjs
var use_combine_values = __webpack_require__(77014);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(3105);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/value/use-transform.mjs





function useTransform(input, inputRangeOrTransformer, outputRange, options) {
    var transformer = typeof inputRangeOrTransformer === "function"
        ? inputRangeOrTransformer
        : transform(inputRangeOrTransformer, outputRange, options);
    return Array.isArray(input)
        ? useListTransform(input, transformer)
        : useListTransform([input], function (_a) {
            var _b = (0,tslib_es6/* __read */.CR)(_a, 1), latest = _b[0];
            return transformer(latest);
        });
}
function useListTransform(values, transformer) {
    var latest = (0,use_constant/* useConstant */.h)(function () { return []; });
    return (0,use_combine_values/* useCombineMotionValues */.N)(values, function () {
        latest.length = 0;
        var numValues = values.length;
        for (var i = 0; i < numValues; i++) {
            latest[i] = values[i].get();
        }
        return transformer(latest);
    });
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,3254,9129,7209,1382,4136,8392,2073,7096,2429,7303,4488,948,3996,8187,8726,7960,6012,3922,8536,3379,4881,2065,5062,814,8302,9774,2888,179], function() { return __webpack_exec__(63319); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);